<script lang="ts">
  /**
   * Reusable Form Field Component
   *
   * Usage:
   * <FormField label="Email" required error={emailError}>
   *   <input type="email" bind:value={email} />
   * </FormField>
   */

  import type { Snippet } from 'svelte';

  interface Props {
    label: string;
    error?: string;
    required?: boolean;
    hint?: string;
    children?: Snippet;
  }

  let { label, error = '', required = false, hint = '', children }: Props = $props();
</script>

<div class="form-group" class:has-error={!!error}>
  <label>
    {label}
    {#if required}
      <span class="required">*</span>
    {/if}
  </label>

  {#if children}
    {@render children()}
  {/if}

  {#if hint && !error}
    <small class="form-help">{hint}</small>
  {/if}

  {#if error}
    <small class="field-error">{error}</small>
  {/if}
</div>
